import { NativeModules } from 'react-native';

type ZyprotectabioModuleType = {
  multiply(a: number, b: number): Promise<number>;
};

const { ZyprotectabioModule } = NativeModules;

export default ZyprotectabioModule as ZyprotectabioModuleType;
